import { useState, useEffect } from "react";

const useFetch = (indexPage, params) => {
	const [events, setEvents] = useState([]);
	const [datesWithEvents, setDatesWithEvents] = useState([]);
	const [message, setMessage] = useState(`Loading ${indexPage}`);
	
	useEffect(() => {
		const request = {
			baseUrl: window.origin,
			endPoint: indexPage,
			params: new URLSearchParams(params),
		}
		
		const url = `${request.baseUrl}/wp-json/futurpreneur/v1/${request.endPoint}?${request.params}`;

		const fetchData = async () => {
			try {
				const response = await fetch(url);
				const encodedResponse = await response.json();
				setMessage("");

				if (!encodedResponse.events) {
					setEvents([]);
					return;
				}

				setEvents(encodedResponse.events);

				if (!params.month || params.location) return;
				setDatesWithEvents(encodedResponse.dates);
			} catch (error) {
				throw new Error(error, "Fetch Error");
			}
		};

		fetchData();

	}, [params]);

	return [events, message, datesWithEvents];
}

export default useFetch;